import { combineReducers } from 'redux';

import breadcrumb from './breadcrumb';
import menu from './menu';
import patient from './patient';
import snackbar from './snackbar';

const reducers = combineReducers({
  breadcrumb,
  menu,
  snackbar,
  patient
});

export default reducers;
